export function functionsReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "NEW_FUNCTION":            
        case "UPDATE_FUNCTION":
            let list = Object.assign({}, state);
            list[payload.function_id] = payload
            
            return list
        case "GET_FUNCTIONS":
            return payload
        default:
            return state;
    }
    
}